module.exports = __webpack_public_path__ + "static/img/banner1.3ce205d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/banner1.jpg
// module id = h9wa
// module chunks = 0